<template>
    <v-container
            id="dashboard"
            fluid
            tag="section"
    >
        <v-row>
            <v-col
                    cols="12"
                    md="12"
            >
                <base-material-card
                        color="primary"
                        class="px-5 py-3"
                >
                    <template v-slot:heading>
                        <v-row>
                            <v-col cols="11" md="11">
                                <div class="display-2 font-weight-light">
                                    Bookings
                                </div>
                                <div class="subtitle-1 font-weight-light">
                                    {{getSubTitle()}}
                                </div>
                            </v-col>
                            <v-col cols="1" md="1">
                                <v-btn class="mx-2" fab dark color="secondary" @click="redirect('bookings/create')">
                                    <v-icon dark>mdi-plus</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </template>
                    <v-card-text>
                        <v-data-table
                                :headers="headers"
                                :items="bookingList"
                                :loading="loading"
                        >
                            <template #item="props">
                                <tr class="v-chip--clickable"
                                        @click="redirect('bookings/' + props.item.id)"
                                >

                                    <td class="text-xs-left">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-icon :color="statusColor(props.item.booking_status)" v-on="on">{{statusIcon(props.item.booking_status)}}</v-icon>
                                            </template>
                                            <span>{{statusTooltip(props.item.booking_status)}}</span>
                                        </v-tooltip>
                                    </td>
                                    <td class="text-xs-left">{{ props.item.id }}</td>
                                    <td class="text-xs-left">{{ props.item.bill_of_lading }}</td>
                                    <td class="text-xs-left">{{ props.item.shipper }}</td>
                                    <td class="text-xs-left">{{ props.item.port_of_discharge }}</td>
                                    <td class="text-xs-left">{{ props.item.invoice_number }}</td>
                                    <td class="text-xs-left">{{ volumeInfo(props.item) }}</td>
                                    <td class="text-xs-left">{{ props.item.etd }}</td>
                                    <td class="text-xs-left">{{ props.item.bol_status }}</td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </base-material-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

    import {mapState, mapActions} from 'vuex'
    import {fromDataTables, dataTablesBookingsList, dataTablesLoading} from '../../../store/selector'
    import {B_UPDATE_BOOKING_LIST} from '../../../store/type'
    import { BOOKING_STATUS } from "../../../modals/enums/booking_status"

    export default {
        name: "Booking",
        data: () => ({
            headers: [
                {text: 'Status', value: 'booking_status'},
                {text: 'Booking #', value: 'id'},
                {text: 'B/L Number', value: 'bill_of_lading'},
                {text: 'Shipper', value: 'shipper'},
                {text: 'POD', value: 'port_of_discharge'},
                {text: 'Shipper Invoice', value: 'invoice_number'},
                {text: 'Volume', value: 'volume'},
                {text: 'ETD', value: 'etd'},
                {text: 'B/L Status', value: 'bol_status'},
            ],
        }),
        computed: {
            ...mapState({ bookingList: dataTablesBookingsList, loading: dataTablesLoading})
        },
        mounted() {
            this.getData();
        },
        methods: {
            ...mapActions({fetchBookings: fromDataTables(B_UPDATE_BOOKING_LIST)}),
            getSubTitle() {
                return `List of bookings as of ${new Date().toLocaleDateString("en-US")}`
            },
            getData() {
                return this.fetchBookings({params: {limit: 10}})
            },
            redirect(path) {
                return this.$router.push(path);
            },
            volumeInfo({volume = null, volume_equipment}) {
                if(volume) {
                    return `${volume} x ${volume_equipment}`
                }
            },
            statusIcon(booking_status = "0") {
                booking_status = parseInt(booking_status);
                switch (booking_status) {
                    case BOOKING_STATUS.INPROGRESS:
                        return 'check_circle_outline';
                    case BOOKING_STATUS.COMPLETED:
                        return 'check_circle';
                    case BOOKING_STATUS.CANCELLED:
                        return 'cancel';
                }
            },
            statusColor(booking_status = "0") {
                booking_status = parseInt(booking_status);
                switch (booking_status) {
                    case BOOKING_STATUS.INPROGRESS:
                        return 'primary';
                    case BOOKING_STATUS.COMPLETED:
                        return 'success';
                    case BOOKING_STATUS.CANCELLED:
                        return 'error';
                }
            },
            statusTooltip(booking_status = "0") {
                booking_status = parseInt(booking_status);
                switch (booking_status) {
                    case BOOKING_STATUS.INPROGRESS:
                        return 'INPROGRESS';
                    case BOOKING_STATUS.COMPLETED:
                        return 'COMPLETED';
                    case BOOKING_STATUS.CANCELLED:
                        return 'CANCELLED';
                }
            }
        }
    };
</script>